.field { margin-bottom: 22px; }
.fieldLast { margin-bottom: 0; }

.label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 7px;
  letter-spacing: .01em;
}

.req { color: var(--red); margin-left: 2px; }

.hint {
  font-size: 13px;
  color: var(--muted2);
  margin-top: 5px;
  line-height: 1.55;
}

.inputRow {
  display: flex;
  gap: 12px;
}

.inputRow > div { flex: 1; }

.inputRow input {
  width: 100%;
}

.numberRow {
  display: flex;
  align-items: center;
  gap: 12px;
}

.numberLabel {
  font-size: 14.5px;
  color: var(--muted);
}

.divider {
  border: none;
  border-top: 1px solid var(--border);
  margin: 22px 0;
}

/* Team prefix — full width, identical to GitHub teams input */
.prefixInput {
  width: 100% !important;
}

/* Timezone select — clean, no background tint */
.select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='none' stroke='%235f6368' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' d='M1 1l4 4 4-4'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 38px !important;
  cursor: pointer;
  max-width: 300px !important;
}
